"use strict";

define('components/filter_bar/table/bulk_create_portal_users',['components/ajax', 'jQuery'], function(ajax, $) {
    var bulkCreatePortalUsersComponent = {
        initWithContext: function(context) {
            var createUserButton = context.buttonbarNode.find('.selection-create-users button');
            createUserButton.click(function() {
                $('#invitation-spinner').removeClass('hidden');
                $('#invitation-button').addClass('disabled');
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();
                
                var formData = new FormData();
                formData.append('objectIds', JSON.stringify(objectIds));

                ajax('/admin_settings/portal_accounts/preview', {
                    formData: formData
                });
            });
        }
    };

    return bulkCreatePortalUsersComponent;
});

